module.exports = __webpack_public_path__ + "img/m2.b97d4105.png";